import { FunctionComponent } from "react";
import { Box } from "@mui/material";

export type VitalBadgeVariant = "good" | "moderate" | "severe" | "critical";

const labels: Record<VitalBadgeVariant, string> = {
  good: "İyi",
  moderate: "Orta",
  severe: "Ağır",
  critical: "Kritik",
};

const VitalBadge: FunctionComponent<{ variant: VitalBadgeVariant; label?: string }> = ({ variant, label }) => {
  const palette: Record<VitalBadgeVariant, { bg: string; border: string; fg: string }> = {
    good: { bg: "#ecfdf5", border: "#a7f3d0", fg: "#047857" },
    moderate: { bg: "#fffbeb", border: "#fcd34d", fg: "#b45309" },
    severe: { bg: "#fff7ed", border: "#fdba74", fg: "#c2410c" },
    critical: { bg: "#fef2f2", border: "#fecaca", fg: "#b91c1c" },
  };
  const c = palette[variant];

  return (
    <Box
      sx={{
        width: "max-content",
        borderRadius: "8px",
        boxSizing: "border-box",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        px: "8px",
        py: "2px",
        textAlign: "right",
        fontSize: "10px",
        fontFamily: "Poppins, sans-serif",
        letterSpacing: "-0.02em",
        lineHeight: "150%",
        border: "1px solid",
        borderColor: c.border,
        bgcolor: c.bg,
        color: c.fg,
        whiteSpace: "nowrap",
      }}
    >
      <Box component="span">{label ?? labels[variant]}</Box>
    </Box>
  );
};

export default VitalBadge;


